import { render } from "./index.vue?vue&type=template&id=5bcb582b&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5bcb582b&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=5bcb582b&lang=scss"
script.render = render
script.__scopeId = "data-v-5bcb582b"

export default script